/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import Button from "@components/Button";

interface SentResultProps {
  onClick: () => void;
  textLine1: string;
  textLine2?: string;
  textBtn: string;
  iconSrc: string;
  isMobile: boolean;
}


const SentResult = ({ onClick, textLine1, textLine2, textBtn, iconSrc, isMobile }: SentResultProps) => {
  return (
    <>
      {isMobile ? (
        <>
          <img alt="sentIcon" src={iconSrc} style={{ width: '150px', marginTop: '50px' }} />
          <h2 className="titleText baseText">
            {textLine1}
            {textLine2 ? <><br />{textLine2}</> : null}
          </h2>
          <Button onClick={onClick}>{textBtn}</Button>
        </>
      ) : (
        <>
          <img alt="sentIcon" src={iconSrc} style={{ width: '90px', marginTop: '30px' }} />
          <h2 className="titleText baseText" style={{fontSize:'22px'}}>
            {textLine1}
          </h2>
          <Button additionalClasses="addPhotosBtnWeb" onClick={onClick}>{textBtn}</Button>
        </>
      )}
    </>
  );
};

export default SentResult;
